<template>
    <AppLayout title="Sucursales">
        <div>
            <div class="sucursales bg-white">
                <Toast />

                <Breadcrumb
                    name="Sucursales"
                    routeName="tiendanube.listado"
                    page="Todas las Sucursales TiendaNube"
                />

                <DataTable
                    :value="branches"
                    responsiveLayout="stack"
                    :paginator="true"
                    dataKey="id"
                    :filters="filters"
                    :rows="10"
                    :rowsPerPageOptions="[10, 20, 50]"
                >
                    <template #header>
                    </template>
                    <Column field="id" header="ID"></Column>
                    <Column field="contacto" header="Contacto"></Column>
                    <Column field="codigo_sucursal" header="Codigo"></Column>
                    <Column field="email" header="Email"></Column>
                    <Column field="json" header="Credencial"></Column>
                    <Column header="Activar">
                        <template #body="slotProps">
                            <div class="flex space-x-2">
                                <Link :href="'/tiendanube/activar/' +slotProps.data.id">
                                    <Button>Activar</Button>
                                </Link>
                            </div>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </AppLayout>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import { Inertia } from "@inertiajs/inertia";
import AppLayout from "@/Layouts/AppLayout.vue";
import Breadcrumb from "@/shared/Breadcrumb.vue";
import Button from "@/shared/Button.vue";
import { Link } from "@inertiajs/inertia-vue3";
import { Plus, PencilAlt, Trash, Key } from "@vicons/fa";
import { Icon } from "@vicons/utils";

export default {
    components: {
        AppLayout,
        Breadcrumb,
        Button,
        Link,
        Plus,
        PencilAlt,
        Trash,
        Icon,
        Key,
    },
    props: {
        // propiedades inyectadas via laravel-inertia
        sucursales: Array,
    },
    data() {
        return {
            branchDialog: false,
            branchApiConfigDialog: false,
            deleteBranchDialog: false,
            branch: {},
            branches: [],
            isLoading: false,
            isEdit: false,
            filters: {},
        };
    },
    created() {
        this.branches = [...this.sucursales];
        this.initFilters();
    },
    methods: {
        hideDialog() {
            this.isLoading = false;
        },
        reloadProps() {
            Inertia.reload({ only: ["sucursales"] });
            this.branches = [...this.sucursales];
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            };
        },
        confirmDelete(branch) {
            this.branch = branch;
            this.deleteBranchDialog = true;
        },
    },
};
</script>

<style>
.v-card-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.v-danger-icon {
    color: #e30032;
}

.v-input-box {
    height: 93px;
}

.table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.sucursales .p-datatable-header {
    background: white;
    border-top: none;
}
.sucursales .p-inputtext-sm {
    border-radius: 0.5rem;
}

.sucursales .p-inputtext-sm:hover {
    border-color: #2e5f98;
}
.sucursales .p-inputtext-sm:enabled:focus {
    border-color: #2e5f98;
    box-shadow: 0 0 0 1px #2e5f98;
}
.sucursales
    .p-paginator
    .p-paginator-pages
    .p-paginator-page.p-highlight:focus {
    border-color: #2e5f98;
}
.sucursales .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
    border-color: #2e5f98;
}

.sucursales .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
    color: #2e5f98;
}
.sucursales .p-link:focus {
    box-shadow: 0 0 0 1px #2e5f98;
}

.sucursales .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
    color: #2e5f98;
}

.sucursales .p-dropdown:not(.p-disabled).p-focus {
    box-shadow: 0 0 0 1px #2e5f98;
    border-color: #2e5f98;
}

.sucursales li.p-dropdown-item.p-highlight,
.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
    color: #2e5f98;
}
</style>